import { defineNuxtPlugin } from '#app';
import { usePostHog } from '#imports';
import { useMainStore } from '../stores/mainStore.js';

// Adds the current school's org IDs as PostHog super properties so homepage (and all)
// pageviews captured by @posthog/nuxt can be broken down per school. Mirrors the
// parent_org / secondary_org dimensions sent to Google Analytics.
export default defineNuxtPlugin({
  name: 'posthog-school-context',
  dependsOn: ['posthog-client'],
  setup() {
    const posthog = usePostHog();
    if (!posthog) {
      return;
    }

    const mainStore = useMainStore();
    posthog.register({
      parent_org: mainStore.parentOrgId,
      secondary_org: mainStore.secondaryOrgId,
      client_domain: window.location.hostname,
    });
  },
});
